document.addEventListener('DOMContentLoaded', () => {
    let lastPositionY = window.scrollY;
    let isMobile = window.innerWidth < 969 ? true : false;

    setFeaturesOffset();
    window.addEventListener('resize', () => requestAnimationFrame(() => setFeaturesOffset()));
    window.addEventListener('scroll', () => {
        requestAnimationFrame(() => {
            isMobile = window.innerWidth < 969 ? true : false;
            setFeaturesOffset();
        })
    });

    function setFeaturesOffset() {
        if(!isMobile) return;

        const sectionFeatures = document.querySelector('section.section-collection-features');

        const header = document.querySelector('header.lux-header');
        const counter = document.querySelector('.counterelement');
        const announcement = document.querySelector('.announcements-section');

        const sectionFeaturesHeight = sectionFeatures ? sectionFeatures.getBoundingClientRect().height : 0;

        // const announcementHeight = announcement ? announcement.getBoundingClientRect().height : 0;
        
        const headerHeight = header ? header.getBoundingClientRect().height : 0;
        const counterHeight = counter ? counter.getBoundingClientRect().height : 0;
        const announcementHeight = 0;

        const currentPositionY = window.scrollY;

        // if scrolling down, hide the section
        // if scrolling up, show the section
        if(lastPositionY < currentPositionY) {
            lastPositionY = currentPositionY;
            if(sectionFeatures) sectionFeatures.style.setProperty('--offset-top', `${-sectionFeaturesHeight}px`);
            return;
        } else {
            const thresholdBase = Math.max(counterHeight, announcementHeight);
            console.log("thresholdbase: ", thresholdBase)
            const thresholdMain = headerHeight + thresholdBase;
            lastPositionY = currentPositionY;

            // if over threshold, offset by total sibling size
            if(sectionFeatures) sectionFeatures.style.setProperty('--offset-top', `${thresholdMain}px`);
            return;
        }            
    };
})